import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ScheduleResult {
    data: any[];
}

// Create calendar event, supplier_id and supplier_category_id maps with Job at backend
export const createSchedule = createAsyncThunk(
    'calendar/create',
    async (params: any, { rejectWithValue }) => {
        const createURL = `${URL_API}/supplier-portal/jobs/${params.jobId }/calendar/events`;

        try {
            const { data } = await axios.post<ScheduleResult>(createURL, params, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            return data;

        } catch (error) {
            // @ts-ignore
            if (error.response?.status === 401) {
                logoutAndRedirect('/sign-in')
            }

            // @ts-ignore
            return rejectWithValue(error.response?.data ?? error)
        }
    }
);
